<template>
  <div>
    <van-sticky :z-index="2001">
      <Wp_nav_bar v-if="showNavBar" title="搜索"></Wp_nav_bar>
      <div style="background-color: white">
        <!--                <Wp_search_model ref="Wp_search_model" :search-value="search_value"-->
        <!--                                 :common-transparent="$common.transparent"-->
        <!--                                 :show-history="false"-->
        <!--                                 :offset-top="offset_top_base"-->
        <!--                                 @clickToSearch="clickToSearch"-->
        <!--                                 @getSearchValue="getSearchValue"-->
        <!--                ></Wp_search_model>-->

        <div style="display: inline-flex; background-color: white">
                    <span style="height: 52px;width: 40px; padding-left: 6px" @click="clickToHome">
                        <div style=" padding-top: 10px; padding-left: 9px">
                            <van-icon class="changelink_icon" name="wap-home-o" size="18"
                                      color="#EE0A24"></van-icon>
                        </div>
                        <div style="text-align: center; margin-top: -8px; padding-left: 2px; color: #EE0A24">首页</div>
                    </span>

          <div :style="{width: ($common.screenWidth - 40) + 'px', height: '52px'}">
            <Wp_search_model ref="Wp_search_model" :search-value="search_value"
                             font-color=""
                             :common-transparent="$common.transparent"
                             @clickToSearch="clickToSearch"
                             @getSearchValue="getSearchValue"
            ></Wp_search_model>
          </div>

        </div>
      </div>
    </van-sticky>

    <div v-if="$store.state.pid">
      <div v-if="has_pdd_tb">
        <div v-if="$common.canShowPdd() || $common.canShowTaobao()">
          <van-tabs v-model="active" sticky :offset-top="offset_top"
                    title-active-color="#219EFF" color="#219EFF"
                    :line-width="($common.screenWidth / 3 - 20) + 'px'"
                    @change="onTabChange">
            <!--                    tab标签高度为44px-->
            <van-tab>
              <div slot="title"><h3>京东</h3></div>

              <Wp_jd_select_simple ref="Wp_jd_select_simple"
                                   :offset-top="offset_top_tab"
                                   :keywords="keywords_jd"
                                   :param-url="url"
              ></Wp_jd_select_simple>

            </van-tab>
            <van-tab>
              <div slot="title"><h3>拼多多</h3></div>
              <Wp_pdd_select_simple ref="Wp_pdd_select_simple"
                                    :offset-top="offset_top_tab"
                                    :keywords="keywords_pdd"

              ></Wp_pdd_select_simple>

            </van-tab>

            <van-tab>
              <div slot="title"><h3>淘宝</h3></div>
              <Wp_tb_select_simple ref="Wp_tb_select_simple"
                                   :offset-top="offset_top_tab"
                                   :keywords="keywords_tb"

              ></Wp_tb_select_simple>

            </van-tab>
          </van-tabs>
        </div>
        <div v-else>
          <Wp_jd_select_simple ref="Wp_jd_select_simple"
                               :offset-top="offset_top"
                               :keywords="keywords_jd"
          ></Wp_jd_select_simple>
        </div>
      </div>
      <div v-else>

        <!--                <Wp_jd_select_simple ref="Wp_jd_select_simple"-->
        <!--                                     :offset-top="offset_top"-->
        <!--                                     :keywords="keywords_jd"-->
        <!--                                     :param-url="url"-->
        <!--                ></Wp_jd_select_simple>-->
        <Wp_jd_select_simple_for_search_model
            v-if="this.url"
            ref="Wp_jd_select_simple"
            :offset-top="offset_top"
            :keywords="keywords_jd"
            :param-url="url">
        </Wp_jd_select_simple_for_search_model>
      </div>

    </div>
    <div v-else>
      <Wp_jd_select_simple_for_search_model
          v-if="this.url"
          ref="Wp_jd_select_simple"
          :offset-top="offset_top"
          :keywords="keywords_jd"
          :param-url="url"
      ></Wp_jd_select_simple_for_search_model>
    </div>

  </div>
</template>

<script>
import Wp_nav_bar from '../custom/Wp_nav_bar'
import Wp_search_model from '../custom/Wp_search_model'
import Wp_jd_select_simple from '../pages/Wp_jd_select_simple'
import Wp_pdd_select_simple from '../pdd/pages/Wp_pdd_select_simple'

import { Toast } from 'vant'
import Wp_tb_select_base from '../tb/pages/Wp_tb_select_base'
import Wp_tb_select_simple from '../tb/pages/Wp_tb_select_simple'
import Wp_jd_select_simple_for_search_model from '../pages/Wp_jd_select_simple_for_search_model'

export default {
  name: 'Wp_search_model_page',
  components: {
    Wp_jd_select_simple_for_search_model,
    Wp_tb_select_simple,
    Wp_pdd_select_simple,
    Wp_jd_select_simple,
    Wp_search_model,
    Wp_nav_bar
  },

  data () {
    return {
      showNavBar: true,

      search_value: '',

      //请求数据页码
      page_index: 1,
      //一次页面请求多少数据
      page_size: 20,

      all_params: {},
      //上拉加载的临时list
      data_list: [],
      url: '',

      check_list: ['优惠券', '京东自营'],
      check_result: ['优惠券'],
      offset_top_base: 0,
      offset_top: 0,
      offset_top_tab: 0,
      offset_top_no_pdd: 0,

      keywords_jd: '',
      keywords_pdd: '',
      keywords_tb: '',
      active: 0,

      has_pdd_tb: false,
    }
  },

  created () {
    let isInput = this.$common.getUrlKey('isInput')
    if (isInput) {
      //如果有值，则表示是从顶部搜索框进入，则显示返回nav_bar
      //顶部nav_bar 46px，搜索框52px，tabs 44px
      this.showNavBar = true
      this.offset_top_base = 46
      this.offset_top = 46 + 52
      this.offset_top_tab = this.offset_top + 44
    } else {
      this.showNavBar = false
      this.offset_top_base = 0
      this.offset_top = 52
      this.offset_top_tab = this.offset_top + 44
    }
  },

  mounted () {
    this.initUserData(() => {
      this.autoSearchByKeyword()
    })

    setTimeout(() => {
      let en_url = this.$common.getUrlKey('url')
      if (en_url) {
        this.url = decodeURIComponent(en_url)
        // this.url = "https://api.wapg.cn/jd_union/recommend/search_recommend?keyword=小米&cid1=1319"

        this.keywords_jd = this.$common.getUrlKey2(this.url, 'keyword')
        // this.search_value = this.keywords_jd;
      }
    }, 200)

  },

  methods: {

    initUserData (fn) {
      let pid = this.$common.getPid()
      if (pid) {
        if (fn) {
          fn()
        }
      } else {
        if (this.$common.isClient_whole()) {
          this.channel_name = this.$common.getUsername()
          // Dialog.alert({
          //     message: 'this.channel_name = ' + this.channel_name
          // });
          if (!this.channel_name) {
            let host = window.location.host
            // host='s101.wapg.cn'
            // this.$log("host = " + host);
            this.channel_name = host.substring(0, host.indexOf('.'))
          }
          this.$log('this.channel_name = ' + this.channel_name)
          if (this.channel_name) {
            this.$getPid(this.channel_name, res => {

              if (res.code === 200) {
                // let _channel_id=res.data.channel_id;
                let _channel_id = res.data.jd_channel_id
                let _channel_name = res.data.channel_name
                let _channel_pdd_pid = ''
                if (res.data.pdd_channel_id) {
                  _channel_pdd_pid = res.data.pdd_channel_id
                }
                let _channel_tb_pid = ''
                if (res.data.tb_channel_id) {
                  _channel_tb_pid = res.data.tb_channel_id
                }
                let user = {
                  username: _channel_name, //_channel_name
                  userId: _channel_name,
                  pid: _channel_id,
                  pdd_pid: _channel_pdd_pid,
                  tb_pid: _channel_tb_pid,
                }
                // this.$store.commit('login', user);
                this.$store.commit('saveChannelData', user)
                if (fn) {
                  fn()
                }
              }
            })
          }
        } else {
          Toast.fail({
            message: '请重新登录'
          })
        }
      }
    },

    clickToHome () {
      this.$router.back()
    },

    autoSearchByKeyword () {
      const loadingToast = Toast.loading({
        message: '加载中...'
      })
      setTimeout(() => {
        let keyword_encode = this.$common.getUrlKey('keyword')

        if (keyword_encode) {
          let keyword = decodeURIComponent(keyword_encode)
          this.search_value = keyword
          this.$refs.Wp_jd_select_simple.search_value = keyword
          this.$refs.Wp_jd_select_simple.check_result = ['优惠券']
          this.clickToSearch()
          loadingToast.clear()
        }
      }, 500)
    },

    onTabChange (v) {
      this.active = v
      if (this.$common.canShowPdd()) {
        if (this.active === 0) {
          this.keywords_jd = this.search_value
          this.$log('this.keywords_jd = ' + this.keywords_jd)
        } else if (this.active === 1) {
          this.keywords_pdd = this.search_value
          this.$log('this.keywords_pdd = ' + this.keywords_pdd)
        } else if (this.active === 2) {
          this.keywords_tb = this.search_value
          this.$log('this.keywords_tb = ' + this.keywords_tb)
        }
      }
    },

    /**
     * 根据条件查询数据
     */
    clickToSearch () {
      if (this.$common.all_limit_words.includes(this.search_value.toUpperCase())) {
        this.getRef().initStatus()
        setTimeout(() => {
          this.getRef().$refs.Wp_pull_list.endLoading()
          this.search_value = ''
        }, 800)

        return
      }
      // if(this.getRef() === this.$refs.Wp_jd_select_simple && this.url){
      //     this.getRef().setUrl(this.url)
      // }

      this.getRef().clickToSearch()
    },

    getSearchValue (value) {
      this.search_value = value
      this.getRef().getSearchValue(value)
    },

    getRef () {
      if (this.has_pdd_tb) {
        if (this.$common.canShowPdd()) {
          if (this.active === 0) {
            return this.$refs.Wp_jd_select_simple
          } else if (this.active === 1) {
            return this.$refs.Wp_pdd_select_simple
          } else if (this.active === 2) {
            this.$log(this.$refs.Wp_tb_select_simple)
            return this.$refs.Wp_tb_select_simple
          } else {
            return this.$refs.Wp_jd_select_simple
          }
        } else {
          return this.$refs.Wp_jd_select_simple
        }
      } else {
        return this.$refs.Wp_jd_select_simple
      }

    },
  }
}
</script>

<style scoped>

.top_tools_div {
  width: 100%;
  min-height: 80px;
  position: fixed;
  top: 0px;
  z-index: 1999;
  padding-bottom: 5px;
  /*box-shadow: 0px 1px 5px #999*/
}
</style>